import AsyncPage from 'pages/AsyncPage'
import { clearUsersToInvite } from 'actions/groups'
import universal from 'react-universal-component'
const component = universal(props => import('./GroupInvitationPage'))

class AsyncGroupInvitationPage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    dispatch(clearUsersToInvite())
  }
}

export default new AsyncGroupInvitationPage()
